const Graphics = () => {
    return (
        <div>
            <h1>Assets Graphics</h1>
        </div>
    )
}

export default Graphics
